import { createSlice } from "@reduxjs/toolkit";
import {
  getAllPacksAction,
  getAllVideosAction,
  getPackDetailsAction,
  getPackNotificationAction,
  getRequestedPacksAction,
} from "../Action/addOnPackAction";

const AddOnPackSlice = createSlice({
  name: "AddOnPack",
  initialState: {
    packs: {},
    requests: {},
    videos: {},
    notification: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllPacksAction.fulfilled, (state, action) => {
      state.packs = action?.payload?.data;
    });
    builder.addCase(getRequestedPacksAction.fulfilled, (state, action) => {
      state.requests = action?.payload?.data;
    });
    builder.addCase(getPackDetailsAction.fulfilled, (state, action) => {
      state.packs = action?.payload?.data;
    });
    builder.addCase(getAllVideosAction.fulfilled, (state, action) => {
      state.videos = action?.payload?.data;
    });
    builder.addCase(getPackNotificationAction.fulfilled, (state, action) => {
      state.notification = action?.payload?.data;
    });
  },
});

export default AddOnPackSlice.reducer;
